import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { map } from 'lodash';
import ImgButton from '~/elements/ImgButton';
import Api from '~/api';
import { CommercialLinksContainer, CommercialLink, ButtonsContainer, ButtonsWrapper, } from './commercialLinks.styles';
import { Feature } from '~/types/common';
import { $preNeedWidget } from '~/atoms/preNeedWidget';
import { featureOn } from '~/utils/featureToggle';
import { isPlanAheadAvailable, isPlanAheadButton } from '~/utils/helpers';
const PLAN_AHEAD_ENABLED = featureOn(Feature.plan_ahead);
const PLAN_AHEAD_BUTTON = isPlanAheadButton();
const CommercialLinks = ({ commercialLinks, page, eventStatus, ...rest }) => {
    const isTestEnv = process.env.NODE_ENV === 'test';
    const planAheadButton = isTestEnv
        ? false
        : PLAN_AHEAD_ENABLED && PLAN_AHEAD_BUTTON && isPlanAheadAvailable();
    if (!commercialLinks && !planAheadButton) {
        return null;
    }
    const filteredCommercialLinks = commercialLinks && PLAN_AHEAD_ENABLED
        ? Object.fromEntries(Object.entries(commercialLinks).filter(([category]) => category !== 'PRE_PLANNING'))
        : commercialLinks;
    const length = (filteredCommercialLinks ? Object.entries(filteredCommercialLinks).length : 0);
    const handleAnalyticClick = (event) => {
        Api.Analytics.commercialClick(event.currentTarget.id, page, eventStatus);
    };
    const handlePreNeedAction = () => {
        $preNeedWidget.set(true);
    };
    return (_jsx(CommercialLinksContainer, { children: _jsx(ButtonsContainer, { children: _jsxs(ButtonsWrapper, { children: [planAheadButton && (_jsx(ImgButton, { onClick: handlePreNeedAction, length: length, category: "PRE_PLANNING", displayRightBorder: length > 0 })), filteredCommercialLinks && map(filteredCommercialLinks, (commercialLink, category) => (_jsx(CommercialLink, { id: category, onClick: handleAnalyticClick, href: commercialLink, target: "_blank", length: length, children: _jsx(ImgButton, { length: length, category: category, ...rest }) }, category)))] }) }) }));
};
export default CommercialLinks;
